(() => {
  if (customElements.get("mr-point")) return;

  class MrPoint extends HTMLElement {
    constructor() {
      super();
      this.emptyErrorMessage = "ポイントを入力してください。";
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;

      this.customerId = this.dataset.customerId;
      const customerTagStr = this.dataset.customerTags;
      this.customerTags = customerTagStr ? customerTagStr.split(",") : [];
      this.totalSpent = this.dataset.totalSpent
        ? Number(this.dataset.totalSpent)
        : 0;
      this.blockType = this.dataset.blockType;
      this.secretKey = this.dataset.secretProxyKey || "";

      this.elContainer = this.querySelector(".js-container");
      this.elContent = this.querySelector(".js-content");
      this.elCurrentPointValue = this.querySelector(".js-current-point-value");
      this.elRankValue = this.querySelector(".js-rank-value");
      this.elUseButton = this.querySelector(".js-use-button");
      this.elUsePoint = this.querySelector(".js-use-point");
      this.elDiscountValue = this.querySelector(".js-point-discount-value");
      this.elApplyPointValue = this.querySelector(".js-apply-point-value");
      this.elUsePointInput = this.querySelector(".js-use-point-input");
      this.elError = this.querySelector(".js-error");

      if (this.blockType === "embed") {
        this.initFormEmbed();
      }

      if (this.blockType === "section") {
        this.initFormSection();
      }
    }

    initFormSection() {
      if (!this.elUseButton || !this.elContainer) return;
      this.initContent();
      this.setUsePointEvent();
    }

    initFormEmbed() {
      const elHeader = this.querySelector(".js-header");
      if (
        !this.elContainer ||
        !this.elContent ||
        !elHeader ||
        !this.elUseButton
      )
        return;
      elHeader.addEventListener("click", () => {
        if (!this.elContainer.classList.contains("is-open")) {
          this.elContainer.classList.add("is-open");
          this.elContent.classList.add("is-open");
          this.elContainer.classList.add("is-loading");

          this.initContent();
        } else {
          this.elContainer.classList.remove("is-open");
          this.elContent.classList.remove("is-open");
        }
      });

      this.setUsePointEvent();
    }

    setUsePointEvent() {
      if (
        !this.elUseButton ||
        !this.elUsePointInput ||
        !this.elError ||
        !this.elContainer ||
        !this.elUsePoint
      )
        return;
      this.elUseButton.addEventListener("click", () => {
        if (this.elUsePoint.classList.contains("is-discount")) {
          this.elContainer.classList.add("is-loading");
          this.commonajax(
            "/apps/mrpoint/reset_use_point",
            {},
            this.resetDiscount.bind(this),
            null,
          );
          return;
        }

        const usePoint = this.elUsePointInput.value;
        if (!usePoint) {
          this.elError.innerHTML = this.emptyErrorMessage;
          return;
        }
        this.elUsePoint.classList.add("is-apply");
        this.elContainer.classList.add("is-loading");
        if (this.elApplyPointValue)
          this.elApplyPointValue.innerHTML = usePoint.toLocaleString();
        this.elError.innerHTML = "";

        const requestJson = {
          secret_key: this.secretKey,
          usepoint: usePoint,
          customer_id: this.customerId,
        };
        this.commonajax(
          "/apps/mrpoint/coupon_generate",
          requestJson,
          this.applyDiscount.bind(this),
          null,
        );
      });
    }

    initContent() {
      const requestJson = {
        secret_key: this.secretKey,
        customer_id: this.customerId,
        tags: JSON.stringify(this.customerTags),
        total_spent: this.totalSpent,
      };

      this.commonajax(
        "/apps/mrpoint/coupon_generate",
        requestJson,
        this.renderPointContent.bind(this),
        null,
      );
      this.renderApplyPoint();
    }

    renderPointContent(data) {
      if (data.err) {
        const timeoutMessage = "接続エラー。ページを更新してください。";
        this.renderError(data, timeoutMessage);
      } else {
        if (this.elContainer) this.elContainer.classList.remove("is-loading");
        if (this.elCurrentPointValue)
          this.elCurrentPointValue.innerHTML = data.point.toLocaleString();
        if (this.elRankValue)
          this.elRankValue.innerHTML = data.rank_name.toLocaleString();
      }
    }

    applyDiscount(data) {
      if (data.err) {
        const timeoutMessage = "接続エラー。再度お試しください。";
        this.renderError(data, timeoutMessage);
      } else {
        fetch(`/discount/${data.coupon_code}`)
          .then((res) => {
            sessionStorage.setItem("mrpointUsePoint", data.usepoint);
            sessionStorage.setItem("mrpointAppliedAt", new Date().getTime());
            this.renderApplyPoint(data.usepoint, true);
          })
          .catch((err) => { console.error(err); });
      }
    }

    renderApplyPoint(applyPoint = null, shouldUpdateTotal = false) {
      let applyPointValue = applyPoint;
      let pointAppliedAt;
      if (!applyPoint) {
        applyPointValue = sessionStorage.getItem("mrpointUsePoint");
        pointAppliedAt = sessionStorage.getItem("mrpointAppliedAt");
      }

      if (applyPointValue && pointAppliedAt) {
        const now = new Date().getTime();
        const elapsedTime = now - Number(pointAppliedAt);
        const validPeriod = 24 * 60 * 60 * 1000;
        if (elapsedTime > validPeriod) {
          sessionStorage.removeItem("mrpointUsePoint");
          sessionStorage.removeItem("mrpointAppliedAt");
          return;
        }
      }

      if (applyPointValue) {
        if (this.elDiscountValue)
          this.elDiscountValue.textContent = applyPointValue;
        if (this.elUseButton)
          this.elUseButton.textContent =
            this.elUseButton.dataset.resetPointText;
        if (this.elUsePointInput) this.elUsePointInput.value = applyPointValue;
        if (this.elContainer) this.elContainer.classList.remove("is-loading");
        if (this.elUsePoint) {
          this.elUsePoint.classList.remove("is-apply");
          this.elUsePoint.classList.add("is-discount");
        }
        if (shouldUpdateTotal) {
          this.updateTotalsDisplay(Number(applyPointValue));
        }
      }
    }

    renderError(data, timioutMessage) {
      if (this.elContainer) this.elContainer.classList.remove("is-loading");
      if (this.elUsePoint) this.elUsePoint.classList.remove("is-apply");
      const message = data.err == "TIMEOUT" ? timioutMessage : data.err;
      if (this.elError) this.elError.innerHTML = message;
    }

    resetDiscount() {
      const NON_EXISTENT_COUPON_CODE = "NON_EXISTENT_COUPON_CODE";
      const resetPoint = Number(sessionStorage.getItem("mrpointUsePoint") || 0);
      fetch(`/discount/${NON_EXISTENT_COUPON_CODE}`)
        .then((res) => {
          sessionStorage.removeItem("mrpointUsePoint");
          sessionStorage.removeItem("mrpointAppliedAt");
          if (this.elDiscountValue) this.elDiscountValue.textContent = "";
          if (this.elUseButton)
            this.elUseButton.textContent =
              this.elUseButton.dataset.usePointText;
          if (this.elUsePointInput) this.elUsePointInput.value = "";
          if (this.elContainer) this.elContainer.classList.remove("is-loading");
          if (this.elUsePoint) this.elUsePoint.classList.remove("is-discount");

          // Reset button click should immediately cancel visual point reduction
          // without depending on page reload.
          this.addBackTotalsDisplay(resetPoint);
        })
        .catch((err) => { console.error(err); });
    }

    addBackTotalsDisplay(point = 0) {
      const totals = document.querySelectorAll(".js-mrpoint-checkout-total-value");
      if (!totals.length) return;

      const safePoint = Number.isFinite(point) ? Math.max(0, Math.floor(point)) : 0;
      if (!safePoint) return;

      for (const totalEl of totals) {
        const currentText = totalEl.textContent;
        const currentTotal = this.extractNumberFromText(currentText);
        if (!Number.isFinite(currentTotal)) continue;

        const adjustedTotal = currentTotal + safePoint;
        const formattedAmount = adjustedTotal.toLocaleString();
        totalEl.textContent = currentText.replace(/[\d,.]+/, formattedAmount);
      }
    }

    updateTotalsDisplay(usePoint = 0) {
      const totals = document.querySelectorAll(".js-mrpoint-checkout-total-value");
      if (!totals.length) return;

      const safeUsePoint = Number.isFinite(usePoint)
        ? Math.max(0, Math.floor(usePoint))
        : 0;

      for (const totalEl of totals) {
        const originalText = totalEl.dataset.originalTotalText || totalEl.textContent;
        totalEl.dataset.originalTotalText = originalText;

        const originalTotal = this.extractNumberFromText(originalText);
        if (!Number.isFinite(originalTotal)) continue;

        const adjustedTotal = Math.max(0, originalTotal - safeUsePoint);
        const formattedAmount = adjustedTotal.toLocaleString();
        totalEl.textContent = originalText.replace(/[\d,.]+/, formattedAmount);
      }
    }

    extractNumberFromText(text) {
      if (!text) return NaN;
      const matched = text.match(/[\d,.]+/);
      if (!matched) return NaN;
      return Number(matched[0].replace(/,/g, ""));
    }

    commonajax(url, requestJson, callback, cbparam) {
      const controller = new AbortController();
      setTimeout(() => {
        controller.abort();
      }, 10000);

      fetch(url, {
        method: "POST",
        body: JSON.stringify(requestJson),
        headers: { "Content-Type": "application/json; charset=utf-8" },
        signal: controller.signal,
      })
        .then((res) => res.json())
        .then((data) => {
          if (callback) callback(data, cbparam);
        })
        .catch((err) => {
          if (err.name == "AbortError") {
            if (callback) callback({ err: "TIMEOUT" }, null);
          } else {
            if (callback) callback({ err: "ERROR" }, null);
          }
        });
    }

  }

  customElements.define("mr-point", MrPoint);
})();
